var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRamLimiterTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RAM Limiter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7143 16.9523H20.5714V17.8094H22.2857V7.52373H1.71429V17.8094H13.7143V16.9523ZM0 5.80945V19.5237H15.4286V18.6666H18.8571V19.5237H24V5.80945H0Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42857 17.8094L3.42857 12.6666H5.14286V17.8094H3.42857Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85714 17.8094V12.6666H8.57143V17.8094H6.85714Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2857 17.8094V12.6666H12V17.8094H10.2857Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49868e-07 12.6666L15.4286 12.6666V14.3809L0 14.3809L1.49868e-07 12.6666Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8571 12.6666H24V14.3809H18.8571V12.6666Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7143 17.8094V12.6666L15.4286 12.6666V17.8094H13.7143Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8571 17.8094V12.6666H20.5714V17.8094H18.8571Z",
    fill: "#FA1E4E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamLimiterTitle);
export default __webpack_public_path__ + "static/media/ramLimiterTitle.6e56a1c2f1d6000e8e30aaad5122fa43.svg";
export { ForwardRef as ReactComponent };